import Clickable from '@web/ui/components/Clickable'

import styles from './UIAcceptFollowNudge.module.scss'

interface Props {
  displayNickname: string
  onAccept?: () => void
  acceptClickCode?: string
}

const UIAcceptFollowNudge = ({ displayNickname, onAccept, acceptClickCode }: Props) => {
  return (
    <div className={styles.following_request_area}>
      <span className={styles.txt}>
        <strong>{displayNickname}</strong>님이 나를 팔로우하고 싶어 해요. 팔로우를 수락하시겠습니까?
      </span>
      <Clickable className={styles.btn_accept} onClick={onAccept} nClickCode={acceptClickCode}>
        수락
      </Clickable>
    </div>
  )
}

export default UIAcceptFollowNudge
